import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WorkItemDiscussionListComponent } from 'components/accordion/workitem-list/workitem-discussion-list/workitem-discussion-list.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgAvatarModule,
    SvgIconModule
  ],
  declarations: [
    WorkItemDiscussionListComponent
  ],
  exports: [
    WorkItemDiscussionListComponent
  ]
})
export class WorkItemDiscussionListModule {}
